import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { css } from 'styled-components';
import { pxToRem } from '@fil-react-mixins/styled';
import IconMap from './IconMap';
export default css(["color:", ";font-size:", ";", " .show-for-sr{position:absolute !important;width:", ";height:", ";padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;clip-path:inset(50%);border:0;}"], function (props) {
  return props.theme.icon.color;
}, function (props) {
  return props.theme.typography.icon.fontSize;
}, function (_ref) {
  var _context;
  var variant = _ref.variant,
    iconType = _ref.iconType,
    unicode = _ref.unicode;
  var iconUnicode = unicode || IconMap[variant ? _concatInstanceProperty(_context = "".concat(iconType, "-")).call(_context, variant) : iconType];
  return iconUnicode && css(["&::after{content:'\\", "';font-family:fidelity-icon-font;font-size:inherit;}"], iconUnicode);
}, pxToRem(1), pxToRem(1));